module.exports = __webpack_public_path__ + "static/media/14_l_dom_0_45.74.6597cf18.png";